import { render, staticRenderFns } from "./storeOrderDetail.vue?vue&type=template&id=1fc53d1e&"
import script from "./storeOrderDetail.vue?vue&type=script&lang=js&"
export * from "./storeOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./storeOrderDetail.vue?vue&type=style&index=0&id=1fc53d1e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports